export const normalizeEmptyBlockElements = (html: string): string => {
  const template = document.createElement('template');
  template.innerHTML = html;

  template.content.querySelectorAll('div').forEach((div) => {
    const onlyContainsBreaks = Array.from(div.children).every((child) => child.tagName === 'BR');

    if (div.textContent?.trim() === '' && onlyContainsBreaks) {
      const paragraph = document.createElement('p');
      paragraph.innerHTML = '&nbsp;';
      div.replaceWith(paragraph);
    }
  });

  return template.innerHTML;
};
